import { ListQuery, Endpoint, Service } from "../../const";

//Organization Actions
const endpoint = Endpoint.User;
const inviteUser = Endpoint.InviteUser;
export const UserService = {
    GetAllData: (data = ListQuery, token = "") => {
        let query = (data.filter ? "filter=" + data.filter : "")
            + (data.skip ? "&skip=" + data.skip : "")
            + (data.limit ? "&limit=" + data.limit : "")
            + (data.from ? "&from=" + data.from : "")
            + (data.to ? "&to=" + data.to : "")
            + (data.fields ? "&fields=" + data.fields : "")
            + (data.sortObj ? "&sortObj=" + encodeURI(JSON.stringify(data.sortObj)) : "")
            + (data.filterObj ? "&filterObj=" + encodeURI(JSON.stringify(data.filterObj)) : "");
        return Service.Request.Get(endpoint + (query !== "" ? ("?" + query) : ""),
            token
        )
    },
    CreateData: (data, token = "") => Service.Request.Post(endpoint, data, token),
    UpdateData: (id, data, token = "") => Service.Request.Put(endpoint + "/" + id, data, token),
    GetDataByUsingId: (id, token = "") => Service.Request.Get(endpoint + "/" + id, token),
    GetDataByUsingEmail: (email, token = "") => Service.Request.Get(endpoint + "/email/" + email, token),
    GetCurrentUser: (token = "", azureToken = "") => Service.Request.Get(endpoint + "/current?key=permission", token, azureToken),
    DeleteData: (id, token = "") => Service.Request.Delete(endpoint + "/" + id, token),
    InviteUser: (data, token = "") => Service.Request.Post(inviteUser, data, token),
    GetLoginUserDetails: (token = "", azureToken = "") => Service.Request.Get(endpoint + "/details", token, azureToken),
    GetAzureUserProfile: (email, token = "", azureToken = "") => Service.Request.Get(endpoint + "/azure/profile?email=" + encodeURI(email), token, azureToken),
    InviteAzureUser: (data, token = "", azureToken = "") => Service.Request.Post(endpoint + "/azure/profile/invite", data, token, azureToken ),
    GetAzureToken: (token = "", azureToken = "") => Service.Request.Get(endpoint + "/azure/token", token, azureToken)
}
